import { IconCurrencyRupee } from "@tabler/icons-react"
import { useEffect, useState } from "react";
import { formatAmountInAlphabets, putCommaInLeadsValue } from "../Utils/helpers/commonhelper";
import { GetRequest, UpdateRF } from "../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

export const Subscription = () => {
    const [currentToggle, setCurrentToggle] = useState(false)

    const [planDetails, setPlanDetails] = useState({})
    const [customer, setCustomer] = useLocalStorageState("customer")
    const navigate = useNavigate()


    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication

    // API headers configuration
    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }
    const isPlan = customer.customer_details?.is_plan === 'yes' ? true : false
    useEffect(() => {
        (async () => {
            try {
                const res = await GetRequest('/plan/fetchAllPlan', { headers }, extras);
                if (res.status === 'fail' || res.success === false) return;

                const mapped = {};
                res.data.forEach(item => {
                    mapped[item.name] = item;
                });

                setPlanDetails(mapped);
            } catch (error) {
                return
            }
        })();
    }, []);
    return (
        <>
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: "full", height: "full", padding: "2rem" }}>
                <div>
                    <div className="d-flex position-relative  " >
                        <h1 className="headingClass" >Plan and Purchase</h1>
                        <div className="position-absolute d-flex gap-2" style={{ right: "-29rem", }}>
                            {
                                isPlan &&
                                <div >
                                    <Button className="btn btn-default" onClick={() => {
                                        navigate("/dashboard")
                                    }}>Return To Dashboard</Button>
                                </div>
                            }
                            <Button className="btn btn-default" onClick={() => {
                                UpdateRF(customer.token?.authentication);
                                setCustomer({
                                    customer_details: {},
                                    customer_status: "Inactive",
                                    user_login: false,
                                    token: {},
                                });
                            }}>Logout</Button>
                        </div>
                    </div>
                    <style jsx>
                        {`
                    .headingClass {
                        font-size : 3.2rem !important;
                        font-weight : 500 !important;
                        font-family : Poppins !important;
                    }
                `}
                    </style>
                    <div className="d-flex align-items-center justify-content-center gap-2">
                        <span style={{ color: `${!currentToggle ? "#007fff" : "black"}`, display: "inline-block", fontWeight: 500, fontSize: "1.2rem" }}>Monthly</span>
                        <button
                            type="button"
                            onClick={() => setCurrentToggle(!currentToggle)}
                            style={{
                                width: "35px",
                                height: "19px",
                                borderRadius: "20px",
                                backgroundColor: currentToggle ? "#7a3a5e" : "#c9c9c9",
                                cursor: "pointer",
                                padding: "3px",
                                position: "relative",
                                border: "1px solid #a69e9e",
                            }}
                            className="shadow"
                        >
                            <div
                                style={{
                                    width: "12px",
                                    height: "12px",
                                    borderRadius: "50%",
                                    backgroundColor: "white",
                                    position: "absolute",
                                    left: currentToggle ? "calc(100% - 17px)" : "2px", // Moves based on state
                                    top: "2px",
                                    transition: "left 0.3s ease", // Smooth movement
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                                }}
                            ></div>
                        </button>
                        <span style={{ color: `${currentToggle ? "#007fff" : "black"}`, display: "inline-block", fontWeight: 500, fontSize: "1.2rem" }}>Yearly</span>

                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-evenly mt-5" style={{ width: "100%" }}>
                    {planDetails && Object.entries(planDetails).map(([k, value]) => (
                        <PlanCard
                            key={k}
                            planDetails={value}
                            pricing={currentToggle ? value?.pricing[1] : value?.pricing[0]}
                            isPopular={Number(value["popular"]) === 0 ? false : true}
                            currentToggle={currentToggle}
                        />
                    ))}
                </div>
            </div >
        </>
    )
}

const PlanCard = ({ planDetails, isPopular, pricing, currentToggle }) => {
    let [totalAmt, setTotalAmt] = useState(0)
    const navigate = useNavigate()
    useEffect(() => {
        if ((pricing?.discount_type === "flat" || pricing?.discount_type === "PERCENT") && Number(pricing?.discount) === 0) {
            setTotalAmt(pricing?.amount)
            return
        } else if (pricing?.discount_type === "flat") {
            setTotalAmt(Number(pricing?.amount) - Number(pricing?.discount))
            return
        } else {
            setTotalAmt(((Number(pricing?.amount) / 100) * Number(pricing?.discount)))
            return
        }

    }, [currentToggle])

    const featuresArr = planDetails?.modules?.map(c => Object.values(c)[0]) || []
    return (
        <div className=" position-relative hoverEff " style={{ animation: "cardEntry 1s ease-out forwards" }}>
            <style jsx>

                {`
                .hoverEff:hover{ 
                    transform : scale(1.01);
                    transition : all .08s 
                                linear, min-width .15s 
                                cubic-bezier(0.4, 0.0, 0.2, 1);
                }
                `}
            </style>
            {
                planDetails?.popular === "1" &&
                <div style={{ position: 'absolute', overflow: "hidden", top: "-10px", right: "-10px", width: "15rem", height: '15rem', }} >
                    <div
                        className="shadow"
                        style={{
                            width: "14rem",
                            height: "auto",
                            padding: "10px 0rem",
                            textWrap: "nowrap",
                            backgroundColor: "#fbc011",
                            color: "white",
                            fontWeight: 600,
                            fontSize: "1rem",
                            textAlign: "center",
                            position: "absolute",
                            top: "2.2rem",
                            left: "4.1rem",
                            transform: "rotate(45deg)"
                        }}> MOST POPULAR </div>
                </div>
            }
            <div
                className="shadow-lg d-flex flex-column align-items-start"
                style={{
                    width: "26rem",
                    height: "35rem",
                    backgroundColor: `${isPopular ? "#0d83fd" : "white"}`,
                    borderRadius: "0.5rem",
                    padding: "2rem",
                    paddingRight: '2rem',
                }}
            >
                <h3
                    style={{
                        fontSize: "2rem",
                        fontWeight: "700",
                        color: `${isPopular ? "white" : "#1f628e"}`,
                        textShadow: "1px 1px 3px rgb(0 0 0 / 10%)",
                        marginBottom: "0.8rem"
                    }}
                >
                    {planDetails?.name}
                </h3>

                <p
                    style={{
                        color: `${isPopular ? "white" : "#808080"}`,
                        fontSize: "1rem",
                        fontWeight: "500",
                        marginBottom: "0.8rem"
                    }}
                >
                    {planDetails?.description}
                </p>

                <div className="d-flex flex-column gap-1 mt-4 mb-1">
                    {
                        Number(pricing?.discount) !== 0 &&
                        <p
                            style={{
                                textDecoration: "line-through",
                                fontSize: "1.1rem",
                                color: `${isPopular ? "white" : "black"}`,
                                fontWeight: "500",
                                marginBottom: "0.8rem"
                            }}
                        >
                            ₹ {(pricing?.amount).toLocaleString()}/-
                        </p>
                    }

                    <div
                        className="d-flex gap-2 align-items-baseline"
                        style={{ marginBottom: "1.2rem" }}
                    >
                        <IconCurrencyRupee
                            size={22}
                            stroke={2}
                            style={{ color: `${isPopular ? "white" : "black"}` }}
                        />
                        <p
                            style={{
                                fontSize: "2.4rem",
                                fontWeight: "bold",
                                color: `${isPopular ? "white" : "black"}`
                            }}
                        >
                            {`${(totalAmt).toLocaleString("en")}`} <span style={{ fontSize: "1rem", }}>/ month</span>
                        </p>
                    </div>
                </div>

                <button
                    style={{
                        fontSize: "1.2rem",
                        fontWeight: "500",
                        backgroundImage:
                            "linear-gradient(90deg, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.1) 100%)",
                        backgroundColor: "#1f628e",
                        color: "white",
                        borderRadius: "5px",
                        border: "none",
                        width: "70%",
                        padding: "7px 10px",
                    }}
                    className="shadow "
                    onClick={() => navigate("/planSummary", {
                        state: {
                            selectedPlan: planDetails?.name,
                            planDetails: planDetails,
                            pricing: pricing,
                            totalAmount: totalAmt
                        }
                    })}
                >
                    Start Now
                </button>

                <div
                    style={{
                        display: "grid",
                        gridTemplateRows: "repeat(8, auto)",
                        gridAutoFlow: "column",
                        gap: "0.4rem 2rem",
                        marginTop: "1rem",
                        textAlign: "left",
                    }}
                >
                    {featuresArr.map((c, i) => (
                        <p key={i} style={{ margin: 0, fontSize: "0.7rem", color: isPopular ? "white" : "black", textWrap: "nowrap" }}>
                            <span style={{ fontSize: "0.7rem", width: "1rem", display: "inline-block" }}>
                                ✓
                            </span>
                            {c}
                        </p>
                    ))}
                </div>
            </div>
        </div >
    )
}